import { render, staticRenderFns } from "./InputFlex.vue?vue&type=template&id=efa4f668&"
import script from "./InputFlex.vue?vue&type=script&lang=js&"
export * from "./InputFlex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports